module.exports = __webpack_public_path__ + "static/img/menu_yy_on.7e7c0a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu_yy_on.png
// module id = 6Imt
// module chunks = 1